import { createFileRoute } from "@tanstack/react-router";

import { StaticPage } from "@/components/site-footer";
import { loadSiteContent, useSiteContent } from "@/lib/content";
import { pageMeta, pageTitle } from "@/lib/seo";

import { publicPageHeaders } from "./-public-cache";

export const Route = createFileRoute("/terms")({
  // already in the cache from the root route; here for the page's title and description
  loader: ({ context }) => loadSiteContent(context.queryClient),
  head: ({ loaderData }) => ({
    meta: pageMeta(
      pageTitle(loaderData?.termsPage.title ?? "شرایط استفاده"),
      loaderData?.termsPage.metaDescription,
    ),
  }),
  headers: publicPageHeaders,
  component: TermsPage,
});

function TermsPage() {
  return <StaticPage page={useSiteContent().termsPage} />;
}
